"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/time-picker/style/css");

var _timePicker = _interopRequireDefault(require("antd/es/time-picker"));

require("antd/es/date-picker/style/css");

var _datePicker = _interopRequireDefault(require("antd/es/date-picker"));

require("antd/es/input/style/css");

var _input = _interopRequireDefault(require("antd/es/input"));

require("antd/es/select/style/css");

var _select = _interopRequireDefault(require("antd/es/select"));

require("antd/es/form/style/css");

var _form = _interopRequireDefault(require("antd/es/form"));

var _react = _interopRequireWildcard(require("react"));

var _moment = _interopRequireDefault(require("moment"));

var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");

var _reactRedux = require("react-redux");

var _AntdIcon = _interopRequireDefault(require("../antdIcon/AntdIcon"));

var selectors = _interopRequireWildcard(require("../../redux/selectors"));

require("./appointmentForm.scss");

var _ActivityTooltip = _interopRequireDefault(require("../activity/ActivityTooltip"));

var _HMPTextArea = _interopRequireDefault(require("../textarea/HMPTextArea"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const {
  Item
} = _form.default;
const {
  Option
} = _select.default;

function filter(input, option) {
  return option && option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0;
}

function range(start, end) {
  const result = [];

  for (let i = start; i <= end; i++) {
    result.push(i);
  }

  return result;
}

function disabledDate(current) {
  return !!(current && current < (0, _moment.default)().startOf('day'));
}

const labelColStyle = {
  padding: 0,
  maxWidth: '40px'
};

class AppointmentForm extends _react.Component {
  constructor(props) {
    super(props);

    this.disabledEndHours = () => {
      const {
        formRef
      } = this.props;
      const form = formRef.current;
      const start = (0, _moment.default)(form === null || form === void 0 ? void 0 : form.getFieldValue('startTime'));
      return range(0, start.hour() - 1);
    };

    this.disabledEndMinutes = () => {
      const {
        formRef
      } = this.props;
      const form = formRef.current;
      const start = (0, _moment.default)(form === null || form === void 0 ? void 0 : form.getFieldValue('startTime'));
      const end = (0, _moment.default)(form === null || form === void 0 ? void 0 : form.getFieldValue('endTime'));
      return (end === null || end === void 0 ? void 0 : end.isSame(start, 'hour')) ? range(0, start.minute()) : [];
    };

    this.onStartTimeBlur = value => {
      const form = this.props.formRef.current;

      if (form) {
        const start = (0, _moment.default)(form.getFieldValue('startTime'));
        const end = (0, _moment.default)(form.getFieldValue('endTime'));

        if (value.isSameOrAfter(end)) {
          // If new startTime is after the previous endTime,
          // we shift the endTime to be the same duration after
          // the new startTime.
          const diff = end.diff(start, 'minutes');
          const newEnd = value.clone();
          newEnd.add(diff, 'minutes');
          form.setFieldsValue({
            startTime: value,
            endTime: newEnd
          });
        } else {
          form.setFieldsValue({
            startTime: value
          });
        }

        this.onChange();
      }
    };

    this.onEndTimeBlur = value => {
      const form = this.props.formRef.current;

      if (form) {
        form.setFieldsValue({
          endTime: value
        });
        this.onChange();
      }
    };

    this.validateTimeRange = (rule, value) => {
      const {
        formRef
      } = this.props;
      const form = formRef.current;

      if (form) {
        const start = form.getFieldValue('startTime');
        const end = form.getFieldValue('endTime');

        if (!_moment.default.isMoment(start) || !_moment.default.isMoment(end)) {
          return Promise.reject();
        }

        return Promise.resolve();
      }
    };

    this.isAvailable = adminId => {
      const {
        availabilities,
        formRef
      } = this.props;
      const form = formRef.current;
      const startDate = form === null || form === void 0 ? void 0 : form.getFieldValue('startDate');
      const startTime = form === null || form === void 0 ? void 0 : form.getFieldValue('startTime');
      const endTime = form === null || form === void 0 ? void 0 : form.getFieldValue('endTime');
      const startMoment = (0, _moment.default)(`${startDate.format('YYYY-MM-DD')} ${startTime.format('hh:mm A')}`, 'YYYY-MM-DD hh:mm A');
      const endMoment = (0, _moment.default)(`${startDate.format('YYYY-MM-DD')} ${endTime.format('hh:mm A')}`, 'YYYY-MM-DD hh:mm A');
      return !!(availabilities === null || availabilities === void 0 ? void 0 : availabilities.filter(a => a.userId === adminId).find(a => (0, _moment.default)(a.startDate).isSameOrBefore(startMoment) && (0, _moment.default)(a.endDate).isSameOrAfter(endMoment)));
    };

    this.sortAdminOptions = () => {
      if (this.props.admin) {
        this.setState({
          adminOptions: this.props.admin.map(a => {
            return {
              value: a.id,
              label: `${a.firstName} ${a.lastName} (${a.username})`
            };
          }).sort((a, b) => this.isAvailable(a.value) ? this.isAvailable(b.value) ? 0 : -1 : 1)
        });
      }
    };

    this.onChange = () => {
      this.props.onChange(); // Resort admin options whenever a value is changed on the form

      this.sortAdminOptions();
    };

    this.state = {
      adminOptions: [],
      participantOptions: []
    };
  }

  componentDidMount() {
    let state = { ...this.state
    };

    if (this.props.participants) {
      state.participantOptions = this.props.participants.map(p => {
        return {
          value: p.id,
          label: `${p.firstName} ${p.lastName} (${p.username})`
        };
      });
    }

    if (this.props.admin) {
      state.adminOptions = this.props.admin.map(a => {
        return {
          value: a.id,
          label: `${a.firstName} ${a.lastName} (${a.username})`
        };
      }).sort((a, b) => this.isAvailable(a.value) ? this.isAvailable(b.value) ? 0 : -1 : 1);
    }

    this.setState(state);
  }

  render() {
    const {
      formRef,
      appointment
    } = this.props;
    const {
      adminOptions,
      participantOptions
    } = this.state;
    const {
      id,
      startDate,
      endDate,
      title,
      participantId,
      adminId,
      adminNotes,
      address,
      phoneNumber,
      notes
    } = appointment;
    return /*#__PURE__*/_react.default.createElement(_form.default, {
      ref: formRef,
      key: "appointment-form",
      colon: false
    }, /*#__PURE__*/_react.default.createElement(Item, {
      name: "title",
      key: `${id}-title`,
      rules: [{
        required: true,
        message: 'Title is required.'
      }, {
        max: 255,
        message: `${title ? `${255 - title.length} characters over` : '255 character limit exceeded'}`
      }],
      initialValue: title
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      placeholder: "Title",
      bordered: false,
      onChange: this.onChange
    })), /*#__PURE__*/_react.default.createElement(Item, {
      className: "parent-form-item",
      style: {
        marginBottom: 0
      }
    }, /*#__PURE__*/_react.default.createElement(Item, {
      name: "startDate",
      key: `${id}-startDate`,
      initialValue: _moment.default.utc(startDate, 'YYYY-MM-DD HH:mm a'),
      rules: [{
        required: true,
        message: 'Start date is required.'
      }],
      style: {
        display: 'inline-block',
        width: 'calc(40% - 8px)'
      }
    }, /*#__PURE__*/_react.default.createElement(_datePicker.default, {
      disabledDate: disabledDate,
      bordered: false,
      onChange: this.onChange,
      format: "YYYY-MM-DD"
    })), /*#__PURE__*/_react.default.createElement(Item, {
      key: `${id}-timeRange`,
      rules: [{
        required: true,
        message: 'Start and end times are required.',
        validator: this.validateTimeRange
      }],
      style: {
        display: 'inline-block',
        width: 'calc(60% - 8px)'
      }
    }, /*#__PURE__*/_react.default.createElement(Item, {
      name: "startTime",
      key: `${id}-startTime`,
      initialValue: (0, _moment.default)(startDate),
      style: {
        marginBottom: 0,
        display: 'inline-block',
        width: 'calc(50% - 4px)'
      }
    }, /*#__PURE__*/_react.default.createElement(_timePicker.default, {
      showNow: false,
      bordered: false,
      onSelect: this.onStartTimeBlur,
      format: "hh:mm A",
      minuteStep: 5
    })), /*#__PURE__*/_react.default.createElement(Item, {
      name: "endTime",
      key: `${id}-endTime`,
      initialValue: (0, _moment.default)(endDate),
      style: {
        marginBottom: 0,
        display: 'inline-block',
        width: 'calc(50% - 4px)'
      }
    }, /*#__PURE__*/_react.default.createElement(_timePicker.default, {
      showNow: false,
      disabledHours: this.disabledEndHours,
      disabledMinutes: this.disabledEndMinutes,
      bordered: false,
      onSelect: this.onEndTimeBlur,
      format: "hh:mm A",
      minuteStep: 5
    })))), /*#__PURE__*/_react.default.createElement(Item, {
      label: /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        classes: "form-item-icon",
        size: "lg",
        fontAwesomeIcon: _proRegularSvgIcons.faUser
      }),
      labelCol: {
        style: labelColStyle
      },
      name: "participantId",
      key: `${id}-participantId`,
      rules: [{
        required: true,
        message: 'Participant is required.'
      }],
      initialValue: participantId,
      style: {
        width: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(_select.default, {
      key: `${id}-participantId-select`,
      placeholder: "Participant",
      bordered: false,
      onChange: this.onChange,
      showSearch: true,
      optionFilterProp: "label",
      filterOption: filter
    }, participantOptions.map(option => /*#__PURE__*/_react.default.createElement(Option, {
      key: `${option.value}-participant-option`,
      value: option.value
    }, option.label)))), /*#__PURE__*/_react.default.createElement(Item, {
      label: /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        classes: "form-item-icon",
        size: "lg",
        fontAwesomeIcon: _proRegularSvgIcons.faUserCog
      }),
      labelCol: {
        style: labelColStyle
      },
      name: "adminId",
      key: `${id}-adminId`,
      initialValue: adminId,
      style: {
        width: 'auto'
      }
    }, /*#__PURE__*/_react.default.createElement(_select.default, {
      key: `${id}-adminId-select`,
      placeholder: "Admin",
      bordered: false,
      onChange: this.onChange,
      showSearch: true,
      optionFilterProp: "label",
      filterOption: filter
    }, adminOptions.map(option => {
      return /*#__PURE__*/_react.default.createElement(Option, {
        key: `${option.value}-admin-option`,
        value: option.value,
        className: this.isAvailable(option.value) ? 'admin-bold' : ''
      }, option.label);
    }))), /*#__PURE__*/_react.default.createElement(Item, {
      label: /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        classes: "form-item-icon",
        size: "lg",
        fontAwesomeIcon: _proRegularSvgIcons.faPhone
      }),
      labelCol: {
        style: labelColStyle
      },
      name: "phoneNumber",
      key: `${id}-phoneNumber`,
      initialValue: phoneNumber
    }, /*#__PURE__*/_react.default.createElement(_input.default, {
      placeholder: "Phone",
      style: {
        width: '150px'
      },
      onChange: this.onChange
    })), /*#__PURE__*/_react.default.createElement(Item, {
      label: /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        classes: "form-item-icon",
        size: "lg",
        fontAwesomeIcon: _proRegularSvgIcons.faMapMarkerAlt
      }),
      labelCol: {
        style: labelColStyle
      },
      name: "address",
      key: `${id}-address`,
      initialValue: address ? address : ''
    }, /*#__PURE__*/_react.default.createElement(_HMPTextArea.default, {
      placeholder: "Address",
      style: {
        width: '100%'
      },
      onChange: this.onChange
    })), /*#__PURE__*/_react.default.createElement(Item, {
      label: /*#__PURE__*/_react.default.createElement(_AntdIcon.default, {
        classes: "form-item-icon",
        size: "lg",
        fontAwesomeIcon: _proRegularSvgIcons.faAlignLeft
      }),
      labelCol: {
        style: labelColStyle
      },
      name: "notes",
      key: `${id}-notes`,
      initialValue: notes ? notes : '',
      tooltip: {
        trigger: ['focus'],
        title: 'This note will be visible to the participant',
        placement: 'topLeft'
      }
    }, /*#__PURE__*/_react.default.createElement(_HMPTextArea.default, {
      spellCheck: true,
      placeholder: "Notes",
      style: {
        width: '100%'
      },
      onChange: this.onChange
    })), /*#__PURE__*/_react.default.createElement(Item, {
      label: /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("span", null, "Admin Notes "), /*#__PURE__*/_react.default.createElement(_ActivityTooltip.default, {
        text: "These notes won't be visible for the participant",
        placement: "top",
        warning: true,
        trigger: "hover"
      })),
      name: "adminNotes",
      key: `${id}-adminNotes`,
      initialValue: adminNotes ? adminNotes : ''
    }, /*#__PURE__*/_react.default.createElement(_HMPTextArea.default, {
      placeholder: "(These notes won't be visible for the participant)",
      style: {
        width: '100%'
      },
      onChange: this.onChange
    })));
  }

}

const mapStateToProps = state => {
  return {
    participants: selectors.getRequestedStudyParticipants(state),
    admin: selectors.getAdmin(state),
    availabilities: selectors.getAvailabilities(state)
  };
};

var _default = (0, _reactRedux.connect)(mapStateToProps)(AppointmentForm);

exports.default = _default;